import {inject, Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from "@angular/router";
import {Observable} from "rxjs";
import {SrmHospitalArbitraryDto} from "../../../../../generated-model/model";
import {environment} from "../../../../../environments/environment";

@Injectable({providedIn: "root"})
export class TasksDetailsResolverService implements Resolve<SrmHospitalArbitraryDto> {
  private http = inject(HttpClient);

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<SrmHospitalArbitraryDto> {
    return this.http.get(`${environment.serverUrl}/api/srm-hospital-arbitrary/${route.paramMap.get('id')}`);
  }
}
